<template>
  <div class="panel-content staff__add">
    <el-form
      class="panel-content__form"
      ref="formData"
      :model="formData"
      :rules="rules"
      label-width="120px"
    >
      <ny-form-item-input required label="员工名称" prop="staffName" v-model="formData.staffName"></ny-form-item-input>
      <ny-form-item-radio
        required
        label="员工类型"
        prop="staffType"
        v-model="formData.staffType"
        :data="roles"
        @change="handleStaffTypeChange"
      ></ny-form-item-radio>
      <ny-form-item-checkbox
        required
        multiple
        label="菜单权限分布"
        prop="permission"
        v-model="formData.permission"
        :key-value="['name', 'id']"
        :data="permissions"
      ></ny-form-item-checkbox>
      <ny-form-item-checkbox
        v-if="others.length > 0"
        required
        multiple
        label="其他功能关联"
        prop="permissions"
        v-model="formData.other"
        :key-value="['name', 'id']"
        :data="others"
      ></ny-form-item-checkbox>
      <ny-form-item-input required label="员工邮箱" prop="email" v-model="formData.email">
        <input type="text" name="name" style="position: absolute;z-index: -1;">
        <input type="password" name="password" style="position: absolute;z-index: -1;">
      </ny-form-item-input>
      <ny-form-item-input
        v-if="type === 'add'"
        type="password"
        autocomplete="off"
        required
        label="员工密码"
        prop="password"
        v-model="formData.password"
      ></ny-form-item-input>
      <ny-form-item-input
        v-if="type === 'add'"
        type="password"
        autocomplete="off"
        required
        label="确认密码"
        prop="repassword"
        v-model="formData.repassword"
      ></ny-form-item-input>
      <ny-form-item-select
        filterable
        label="广告主"
        prop="adUser"
        v-model="adUser"
        :data="adUsers"
        @change="handleAdUserChange"
      ></ny-form-item-select>
      <div class="panel-content__table-wrap">
        <ny-table
          class="panel-content__table"
          :page="adUserPage"
          :pagination="false"
          :width-columns="{ permission: 200 }"
          :slot-columns="['permission']"
          @current-change="handlePageChange"
          @size-change="handlePageChange"
        >
          <template slot="permission" slot-scope="scope">
            <ny-checkbox v-model="scope.row.permission" :data="adUserPermissions"></ny-checkbox>
          </template>
          <template slot="operate" v-if="adUserPage.data.length">
            <el-table-column label="操作" width="180" fixed="right" align="center">
              <template slot-scope="scope">
                <ny-popover
                  class="panel-content__table-icon"
                  tip-text="确定要删除该广告主吗？"
                  :confirm="() => handleRemoveAdUser(scope.row)"
                >
                  <el-button size="small" class="is-remove" slot="reference">删除</el-button>
                </ny-popover>
              </template>
            </el-table-column>
          </template>
        </ny-table>
      </div>
      <div class="panel-content__btn-group is-center">
        <div class="panel-content__btn" v-if="type !== 'view'">
          <el-button size="large" @click="submitForm('formData')">{{submitText}}</el-button>
        </div>
        <div class="panel-content__btn">
          <el-button
            size="large"
            class="is-cancel"
            @click="$router.go(-1)"
          >{{ type === 'view' ? '返回' : '取消'}}</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { NyFormItemRadio, NyFormItemInput, NyFormItemCheckbox, NyFormItemSelect, NyTable, NyPopover, NyCheckbox } from '@/global/components'
import Page from '@/global/util/Page';
import { tip } from '@/global/util/util';
import { get, post, patch } from '@/agent/http';

export default {
  name: 'staff-add',

  components: {
    NyFormItemRadio,
    NyFormItemInput,
    NyFormItemCheckbox,
    NyFormItemSelect,
    NyTable,
    NyPopover,
    NyCheckbox
  },

  data () {
    return {
      formData: {
        staffName: '',
        staffType: '',
        permission: [],
        other: [],
        email: '',
        password: '',
        repassword: ''
      },
      adUser: '',
      rules: {
        staffName: [{ required: true, message: '请输入员工名称', trigger: 'blur' }],
        staffType: [{ required: true, message: '请选择员工类型', trigger: 'change' }],
        permission: [
          { type: 'array', required: true, message: '请至少选择一个权限', trigger: 'change' }
        ],
        email: [
          { required: true, message: '请输入员工邮箱', trigger: 'blur' },
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
        ],
        password: [
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              let re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,20}$/
              if (value === '') {
                callback(new Error('请输入员工密码'));
              } else if (value.length > 20 || value.length < 6) {
                callback(new Error('密码长度不少于6个字符,不超过20个字符'));
              } else if (!re.test(value)) {
                callback(new Error('密码至少包含大写字母，小写字母，数字'));
              } else {
                if (this.formData.repassword !== '') {
                  this.$refs.formData.validateField('repassword');
                }
                callback();
              }
            }
          }],
        repassword: [
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入确认密码'));
              } if (value && value !== this.formData.password) {
                callback(new Error('确认密码与密码不一致'))
              } else {
                callback()
              }
            }
          }
        ]
      },
      page: new Page(),
      adUserPermissions: [
        { name: '操作', value: '1' },
        { name: '数据', value: '2' }
      ],
      plat: 'agency',
      type: '',
      id: '',
      submiting: false,
      submited: false
    }
  },

  computed: {
    ...mapGetters({
      userid: 'login/userid',
      roles: 'staff/roles',
      permissions: 'staff/permissions',
      others: 'staff/others',
      adUsers: 'staff/adUsers',
      adUserPage: 'staff/adUserPage'
    }),
    submitText () {
      return this.submiting ? '提交中...' : (this.submited ? '已提交' : '提交')
    }
  },

  async created () {
    const { id, type } = this.$route.params
    this.id = id
    this.type = type

    this.adUserPage.clearData()
    this.adUserPage.loading = false

    await Promise.all([
      this.getRoleTypes(),
      this.getAdUsers()
    ])

    if (id) {
      this.adUserPage.loading = true
      this.getStaff(id)
    }
  },

  methods: {
    ...mapActions([
      'staff/getRoleTypes',
      'staff/getPermissions',
      'staff/getAdUsers',
      'staff/getAdUser',
      'staff/addStaff',
      'staff/findStaff',
      'staff/updateStaff'
    ]),
    async getRoleTypes () {
      const data = await this['staff/getRoleTypes']({ request: get })
      if (!this.id) {
        this.formData.staffType = data[0].value
      }
    },
    getPermissions (staffType) {
      this['staff/getPermissions']({ request: get, params: { plat: this.plat, user_type: staffType } })
    },
    getAdUsers () {
      this['staff/getAdUsers']({ request: get, params: { plat: this.plat } })
    },
    async getStaff (id) {
      const staff = await this['staff/findStaff']({ request: get, plat: this.plat, id })

      Object.assign(this.formData, {
        staffName: staff.username,
        staffType: staff.id_tag,
        email: staff.email,
        permission: staff.menu_p.map(v => parseInt(v.id, 10)),
        other: staff.other_p.map(v => parseInt(v.id, 10))
      })
    },
    handleStaffTypeChange (staffType) {
      this.getPermissions(staffType)
    },
    handleAdUserChange (value) {
      if (this.adUserPage.data.find(v => v.id === parseInt(value, 10))) {
        return tip('已经添加过了', { type: 'info', duration: 1000 })
      }

      this['staff/getAdUser']({ request: get, id: value })
    },
    handleRemoveAdUser (row) {
      this.adUserPage.data = this.adUserPage.data.filter(item => item.id !== row.id)
    },
    handlePageChange ({ currentPage, pageSize }) {
      // this.adUserPage.data = this.adUserPage.data.slice((currentPage - 1) * pageSize, currentPage * pageSize)
    },
    submitForm (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.submiting || this.submited) return tip('请勿重复提交员工信息')
          this.submiting = true
          const pageData = this.adUserPage.data
          const { staffName, staffType, email, password, repassword, permission, other } = this.formData

          const formData = {
            plat: this.plat,
            user_name: staffName,
            email,
            parent_id: this.userid,
            id_tag: staffType,
            p_ids: permission.concat(other),
            ader_ids: pageData.map(v => v.id),
            operate_permisson: pageData.filter(v => v.permission.indexOf('1') > -1).map(v => v.id),
            data_permisson: pageData.filter(v => v.permission.indexOf('2') > -1).map(v => v.id)
          }

          if (!this.id) {
            formData.password = password
            formData.password_confirmation = repassword
          }

          let data
          if (!this.id) {
            data = await this['staff/addStaff']({ request: post, params: formData })
          } else {
            data = await this['staff/updateStaff']({ request: patch, params: formData, id: this.id })
          }

          const operText = this.id ? '编辑' : '添加'

          if (data.code === 1) {
            this.submiting = false
            this.submited = true
            return tip(`${operText}员工成功`, { type: 'success' }, () => {
              this.$router.push('/staff')
            })
          } else {
            this.submiting = false
            // return tip(`${operText}加员工失败`)
            return tip(data.msg)
          }
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
